<template>
  <div class="display-description-wrapper">
    <div v-if="!value" class="skeleton-wrapper">
      <van-skeleton title :row="5" />
    </div>
    <div v-else class="description-wrapper ql-container">
      <div v-html="value" class="ql-editor" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [String],
  },
};
</script>
<style lang="less" scoped>
.display-description-wrapper {
  background: #fff;
  .skeleton-wrapper {
    padding-top: 16px;
  }
  // box-sizing: border-box;
  // word-wrap: break-word;
  // width: 100%;
  overflow: hidden;
  /deep/ img {
    max-width: 100%;
  }
}
</style>
